import React, { useState } from "react";
import cn from "classnames";
import styles from "./Item.module.sass";
import ReactHtmlParser from "react-html-parser";

const Preview = ({ className, item }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={cn(className, styles.item, { [styles.active]: visible })}>
      <div className={styles.head} onClick={() => setVisible(!visible)}>
        {item.title}
      </div>
      <div className={styles.body}>
        <div className={styles.content}>
          {ReactHtmlParser(item.description)}{" "}
        </div>
        {/*}
        <button className={cn("button-stroke button-small", styles.button)}>
          Learn more
        </button>
        */}
      </div>
    </div>
  );
};

export default Preview;
